import { TakeOver } from './take-over';

export default {
  tag: 'takeover',
  format: `<TakeOver />`,
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <TakeOver {...props} />;
  },
};
